import React, { useEffect } from "react";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import ipWhitelistingBlockedIllustration from "../../assets/images/ip-whitelisting-blocked-illustration.png";
import { clear, clearAllCookies } from "../../helpers/localStorage";

const IpWhitelistingBlocked = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevHtmlHeight = html.style.height;
    const prevBodyHeight = body.style.height;

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    html.style.height = "100%";
    body.style.height = "100%";

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      html.style.height = prevHtmlHeight;
      body.style.height = prevBodyHeight;
    };
  }, []);

  const handleBackToLogin = () => {
    clear();
    clearAllCookies();
    navigate("/login", { replace: true });
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        height: "100dvh",
        overflow: "hidden",
        padding: "clamp(20px, 5vh, 56px) clamp(16px, 5vw, 72px)",
        display: "grid",
        gridTemplateColumns: "1.1fr 1fr",
        gap: "clamp(20px, 4vw, 48px)",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
      }}
    >
      <div>
        <Typography style={{ fontSize: 44, fontWeight: 800, color: "#101828" }}>
          IP Whitelisting
        </Typography>
        <Typography style={{ color: "#667085", fontSize: 14, marginTop: 8 }}>
          Your current IP address is restricted. Please contact your administrator
          to get access.
        </Typography>
        <div style={{ marginTop: 22 }}>
          <Button
            onClick={handleBackToLogin}
            style={{
              height: 36,
              borderRadius: 8,
              fontWeight: 600,
              borderColor: "#EAECF0",
              color: "#344054",
            }}
          >
            ← Back to Login
          </Button>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={ipWhitelistingBlockedIllustration}
          alt=""
          role="presentation"
          style={{
            width: "100%",
            maxWidth: 620,
            height: "auto",
            objectFit: "contain",
          }}
        />
      </div>
    </div>
  );
};

export default IpWhitelistingBlocked;

